import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './App.css'
import { Route, Link, Router, Switch, Redirect } from 'react-router-dom'
import Chat from './components/chat/Chat'
import Notfound from './components/404'
import UserList from './components/chat/UserList'
import Users from './components/users'
import Login from './components/login'
import Profile from './components/Profile'
import Contact from './components/contact'
import Home from './components/Home'
import ArticlePage from './components/ArticlePage'
import Quiz from './components/quiz/Quiz'
import ConsultRequests from './components/consult/ConsultRequests'
// import Quiz from './components/consult/Quiz'
import ConsultHistory from './components/consult/ConsultHistory'
import { BaseUrl } from './settings'
import Matrix from './scripts/Matrix'
import NewConsult from './components/consult/NewConsult'
import CreateConsult from 'components/consult/create-consult'
import ReactGA from 'react-ga';
// import { createBrowserHistory } from 'history';
import history from './history';
import Intro from './components/Intro'
import DoctorProfile from './components/consult/DoctorProfile'
import AboutUs from './components/AboutUs'
import TermsAndCondition from './components/TemsAndCondition'
import CallList from './components/CallList'
import CategoryList from 'components/consult/CategoryList'
import DoctorsConsultCategory from 'components/consult/DoctorsConsultCategory'
import QuestionPreview from './components/QuestionPreview'
import Utils from './Utils'
import moment from 'moment-jalaali'
import ModalWarning from './components/ModalWarning'
import IncomingCall from './components/call/Incoming'
import Calling from './components/call/Calling'
import VpnModalWarning from './components/VpnModalWarning'

// import ItineraryMaker from './components/calendar'

function initializeReactGA() {
  // console.log('initializing GA -------------------------')
  ReactGA.initialize('UA-109009253-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

initializeReactGA()


// Initialize google analytics page view tracking
history.listen(location => {
  // console.log('here in history listener ------------', location)
  ReactGA.pageview(location.pathname + location.search);
});


const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    Matrix.isLoggedIn() === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const App = () => {
  const modalWarning = useRef()
  const vpnModalRef = useRef()
  var sUsrAg = navigator.userAgent
  const isIran = window.isIran
  
  useEffect(()=> {
    console.log(modalWarning.current)
    if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      modalWarning.current.openModal()
    }}, [modalWarning])

  useEffect ( () => {
    if(isIran === "false"){
      vpnModalRef.current.openModal()
    }
  }, [vpnModalRef])
  

  const [introShow, setIntroShow] = useState(localStorage.getItem('introShow') === 'true')
  let [matrixCall, setMatrixCall] = useState(false)
  let [incomingCall, setIncomingCall] = useState(null)
  let [roomId, setRoomId] = useState(null)
  let [displayName, setDisplayName] = useState('')
  let [avatar, setAvatar] = useState(null)
  let [incomComp, setIncomComp] = useState(null)
  let callingComp
  let incomingComp

//   useEffect(() => {
//     handleEvent()
//   }, [])
  
  const handleEvent = async () => {
    const client = await Matrix.login()
    if (client) {
      client.on('Call.incoming', async (call) => {
          const room = client.getRoom(call.roomId)
          const joindMember = room.getJoinedMembers()
          const mainMember = Utils.mainMember(joindMember, Matrix.getUserId())

          await setDisplayName(mainMember.user.displayName)
          await setAvatar(mainMember.getAvatarUrl('https://msg.tebinja.com'))

          await setRoomId(call.roomId)
          await setIncomingCall(true)
          await setMatrixCall(call)
      })
    }
  }

  Matrix.onClientCreated(handleEvent)

  const setIntro = (val) => {
    localStorage.setItem('introShow', val)
    setIntroShow(val)
  }

  const queries = new URLSearchParams(window.location.search)

  if (queries.get('tatoken') && queries.get('utm_source')) {
    const takhfifanToken = queries.get('tatoken')
    const utmSource = queries.get('utm_source')

    if (utmSource === 'takhfifan') {
      Utils.getCookies().set('tatoken', takhfifanToken, { expires: moment().add(30, 'days').toDate(), domain: '.tebinja.com' })
    }
  }

  if (queries.get('question')) {
    const question = queries.get('question')
    const categoryId = queries.get('id')
    setIntro(true)

    window.history.pushState(null, null, window.location.pathname)

    window.localStorage.setItem('questionFromBlog', JSON.stringify({ question, categoryId }))
  }

  useEffect(() => {
    if (window.location.pathname === '/categories') setIntro(true)
  }, [])

  const acceptCall = () => {
    callingComp.acceptCall(roomId, matrixCall)
    incomingComp.hide()
    callingComp.show(true)
  }

  const endCall = () => {
    if(matrixCall.state==='connected') 
      matrixCall.hangup()
    else if(matrixCall.state==='ringing')  
      matrixCall.reject()
    // incomingComp.hide()
    setIncomingCall(false)
    setMatrixCall(null)
  }

  return (
    <Router history={history}>
      <div className="root-new">
        {!introShow &&
          <Intro setIntroShow={setIntro}></Intro>
        }
        <Switch>

          <Route path={"/login"} component={Login} />
          {/* <Route path={"/home"} component={Home} /> */}
          <Route path={"/test"} component={Quiz} />
          <Route path={"/article/:id"} component={ArticlePage} />
          <Route path={"/contact"} component={Contact} />
          <Route path={"/aboutUs"} component={AboutUs} />
          <Route path={"/terms-condition"} component={TermsAndCondition} />
          {/* <Route path={BaseUrl + "/addtodo"} component={AddToDo} /> */}
          {/* <Route path={BaseUrl + "/it/:id/"} component={AsyncComponent} />  */}
          <PrivateRoute path={"/consult/new"} component={CreateConsult} />
          {/* <PrivateRoute path={"/consult/new"} component={CreateConsult} /> */}
          <PrivateRoute path={"/chat/:id/"} component={Chat} />
          <PrivateRoute path={"/chats"} component={UserList} />
          {/* <PrivateRoute path={"/consults"} component={ConsultRequests} /> */}
          <PrivateRoute path={"/profile"} component={Profile} />
          {/* <PrivateRoute path={"/quiz/:id"} component={Quiz} /> */}
          <PrivateRoute path={"/consultHistory/:consultRequestId"} component={ConsultHistory} />
          <PrivateRoute path={"/question"} component={QuestionPreview} />
          <Route path={"/doctors/:doctorId"} component={DoctorProfile} />
          <Route path={"/calls"} component={CallList} />
          <Route path="/categories" component={CategoryList} exact />
          <Route path="/categories/:id/doctors" component={DoctorsConsultCategory} />

          <PrivateRoute path={"/"} component={UserList} />
          <Route component={Notfound} />

        </Switch>

        {(incomingCall && matrixCall) && <IncomingCall ref={el => { incomingComp = el; matrixCall.on('hangup', () => endCall()) }} userFullname={displayName} profileImage={avatar} matrixCall={matrixCall} isIncoming={true} onClickAcceptCall={acceptCall} onClickEndCall={endCall}/>}
        <Calling ref={el => { callingComp = el }} open={true} client="" roomId="" matrixCall=""/>

      </div>
      <ModalWarning ref={ modalWarning } />
      <VpnModalWarning ref={ vpnModalRef } />
    </Router>
  );
}

export default App;
